import Component from './sound-system'

export default Component
